export const getLocationHash = () => window.location.hash;
export const getLocationHref = () => window.location.href;
export const getLocationHost = () => window.location.host;
export const getLocationPathname = () => window.location.pathname;
export const getLocationOrigin = () => window.location.origin;
